import Helper from '@ember/component/helper';
import { get } from '@ember/object';

export default Helper.extend({
  /*
    Returns a custom property item by its label

    namedArgs
      - custom
        - contact.custom or entity.custom
      - label
        - the label of the property to show
  */
  compute(args, namedArgs) {
    let properties = get(namedArgs.custom, 'properties');
    if (properties == null) {
      return undefined;
    }
    return properties.find((x) => x['l'] === namedArgs.label);
  },
});
